import Footer from '@/components/common/Footer';
import Sidebar from '@/components/common/Sidebar';
import Header from '@/components/Header';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return (
    <div>
      <Header onMenuClick={() => setIsSidebarOpen(true)} />

      <div className="flex xl:mt-1 min-h-[calc(100vh-169px)]">
        <Sidebar isOpen={isSidebarOpen} onToggle={() => setIsSidebarOpen(false)} />

        <main className="flex-1 overflow-hidden">
          <Outlet />
        </main>
      </div>
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default MainLayout;
